import { RestSlice } from '../../../../../redux/rest.slice';
import { Unit } from '@rcp/types';
import { localizationService, Resource } from 'src/services';

export const settingLookupsUnitSlice = new RestSlice<Unit>(
	localizationService.getLocalizedString('cccSettings.lookupUnits'),
	`Settings/${Resource.Units}`
);
export default settingLookupsUnitSlice.rests.reducer;
